const copyIconBrown = (
  <svg
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25"
      cy="25.2773"
      r="25"
      fill="var(--custom-social-icon-background-color, #4C3437)"
    />
    <path
      d="M26.2634 20.2753C27.103 20.6191 27.8663 21.1276 28.5065 21.7704C29.2582 22.515 29.8226 23.4271 30.155 24.4316C30.3833 25.1312 30.4989 25.8626 30.4977 26.5986C30.4946 28.4117 29.774 30.1497 28.4929 31.4325L22.8727 37.0458C21.5806 38.2673 19.8626 38.937 18.0847 38.912C16.3069 38.8869 14.6085 38.1693 13.3513 36.912C12.0941 35.6547 11.3773 33.9565 11.3522 32.1786C11.3272 30.4007 11.9961 28.6828 13.2175 27.3906L18.0729 22.5419C17.8357 23.7779 17.8862 25.0522 18.2204 26.2656L15.155 29.3281C14.4857 29.9967 14.0691 30.8768 13.9763 31.8183C13.8834 32.7599 14.1202 33.7046 14.6462 34.4911C15.1721 35.2777 15.9544 35.8578 16.8601 36.1318C17.7657 36.4057 18.7384 36.3563 19.612 35.9931C20.1067 35.7862 20.5563 35.4847 20.9352 35.1054L26.5651 29.496C27.1124 28.9534 27.4916 28.2637 27.6559 27.5107C27.7854 26.9442 27.7924 26.3564 27.6765 25.787C27.5604 25.2176 27.324 24.6787 26.9831 24.2079C26.6423 23.7374 26.2045 23.3454 25.6999 23.0575C25.1951 22.7696 24.634 22.5928 24.0554 22.539C24.1424 22.4177 24.239 22.3029 24.3434 22.1962L26.2634 20.2753ZM30.4841 11.7607C31.8079 11.4984 33.1806 11.634 34.4274 12.1503C35.6741 12.6667 36.7402 13.5407 37.4909 14.662C38.2416 15.7835 38.6438 17.1025 38.6462 18.4521C38.647 19.3486 38.4699 20.2365 38.1257 21.0644C37.7814 21.8924 37.2767 22.6445 36.6403 23.2763L31.7888 28.1308C31.8839 27.6243 31.934 27.11 31.9392 26.5947C31.9365 25.8521 31.8349 25.1132 31.6374 24.3974L34.696 21.3388C35.2689 20.7684 35.66 20.0407 35.819 19.248C35.978 18.4551 35.8974 17.632 35.5886 16.8847C35.2797 16.1376 34.7558 15.499 34.0837 15.0497C33.4114 14.6005 32.6208 14.3608 31.8122 14.3613C31.275 14.3597 30.7429 14.4648 30.2468 14.6708C29.7506 14.8768 29.3007 15.1798 28.9226 15.5615L23.3093 21.1708C22.7831 21.6982 22.4117 22.36 22.236 23.0839C22.2206 23.1234 22.2108 23.1648 22.2058 23.207C22.0846 23.7693 22.0834 24.3513 22.2028 24.914C22.3224 25.4768 22.5598 26.0089 22.8991 26.4736C23.2383 26.938 23.6721 27.3252 24.1716 27.6103C24.6713 27.8954 25.2259 28.0721 25.7985 28.1279C25.7128 28.2493 25.6179 28.364 25.5143 28.4706L23.5905 30.3906C22.6765 30.0162 21.8547 29.4481 21.1813 28.7255C20.508 28.0028 19.9991 27.1423 19.6901 26.204C19.3812 25.2658 19.2791 24.2714 19.3913 23.29C19.5036 22.3087 19.8278 21.3636 20.3405 20.5195C20.6317 20.051 20.9768 19.6183 21.3688 19.2304L26.988 13.624C27.9437 12.6713 29.1604 12.023 30.4841 11.7607Z"
      fill="var(--custom-social-icon-color, #FFAFB8)"
    />
  </svg>
);

const copyIconTransparent = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7426 9.06836C13.2347 9.26988 13.6817 9.56755 14.057 9.94434C14.4976 10.3807 14.829 10.9152 15.0238 11.5039C15.1577 11.914 15.2257 12.343 15.225 12.7744C15.2232 13.8373 14.8003 14.8564 14.0492 15.6084L10.7543 18.8984C9.99679 19.6145 8.98995 20.0068 7.94766 19.9922C6.90551 19.9775 5.91026 19.5573 5.17325 18.8203C4.43626 18.0833 4.01515 17.088 4.0004 16.0459C3.98575 15.0038 4.37836 13.9967 5.09415 13.2393L7.94083 10.3965C7.8018 11.1209 7.83097 11.8679 8.02676 12.5791L6.22989 14.374C5.83758 14.7659 5.59396 15.2822 5.53946 15.834C5.48505 16.386 5.6237 16.9403 5.93204 17.4014C6.24035 17.8623 6.69907 18.2017 7.22989 18.3623C7.76075 18.5229 8.33104 18.4951 8.84317 18.2822C9.13324 18.1609 9.39635 17.9832 9.61856 17.7607L12.9193 14.4727C13.2401 14.1546 13.4627 13.7509 13.559 13.3096C13.6349 12.9775 13.6387 12.6326 13.5707 12.2988C13.5027 11.965 13.3643 11.649 13.1645 11.373C12.9646 11.0971 12.7074 10.867 12.4115 10.6982C12.1157 10.5296 11.7867 10.426 11.4477 10.3945C11.4987 10.3233 11.5553 10.256 11.6166 10.1934L12.7426 9.06836ZM15.2162 4.07617C15.9923 3.92242 16.7968 4.002 17.5277 4.30469C18.2586 4.60738 18.8835 5.11998 19.3236 5.77734C19.7637 6.43471 19.999 7.20794 20.0004 7.99902C20.0009 8.52458 19.8975 9.04499 19.6957 9.53027C19.4939 10.0157 19.1977 10.4568 18.8246 10.8271L15.9809 13.6729C16.0367 13.3759 16.0667 13.0746 16.0697 12.7725C16.0682 12.3371 16.0078 11.904 15.892 11.4844L17.685 9.69141C18.0209 9.35696 18.25 8.92962 18.3432 8.46484C18.4363 8.00017 18.3894 7.51806 18.2084 7.08008C18.0274 6.64225 17.7204 6.2682 17.3266 6.00488C16.9325 5.74148 16.4686 5.60032 15.9945 5.60059C15.6799 5.59973 15.3682 5.66163 15.0775 5.78223C14.7867 5.903 14.5219 6.08097 14.3002 6.30469L11.0102 9.59277C10.7018 9.90184 10.4843 10.2896 10.3813 10.7139C10.3722 10.737 10.3656 10.7615 10.3627 10.7861C10.2917 11.1158 10.2917 11.4572 10.3617 11.7871C10.4318 12.117 10.571 12.4288 10.7699 12.7012C10.9688 12.9734 11.2232 13.2001 11.516 13.3672C11.8089 13.5343 12.1336 13.6382 12.4691 13.6709C12.4189 13.742 12.3638 13.8096 12.3031 13.8721L11.1752 14.9971C10.6393 14.7776 10.1569 14.4452 9.76211 14.0215C9.36738 13.5978 9.0692 13.093 8.88809 12.543C8.70708 11.9931 8.6475 11.4101 8.71329 10.835C8.77911 10.2597 8.96934 9.70579 9.26993 9.21094C9.44061 8.93634 9.64263 8.68249 9.87247 8.45508L13.1674 5.16895C13.7276 4.61054 14.4403 4.22993 15.2162 4.07617Z"
      fill="#636369"
    />
  </svg>
);

const facebookIcon = (
  <svg
    width="32"
    height="32.444"
    viewBox="0 0 32 32.444"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      cx="36.25"
      cy="36.6113"
      r="35.75"
      fill="var(--custom-social-icon-background-color, #4C3437)"
      d="M32 16.272A15.889 15.889 0 0 1 16.111 32.161A15.889 15.889 0 0 1 0.222 16.272A15.889 15.889 0 0 1 32 16.272z"
    />
    <path
      d="m20.556 16.949 0.487 -3.004H18v-1.952c0 -0.821 0.424 -1.624 1.787 -1.624h1.383v-2.561a17.333 17.333 0 0 0 -2.455 -0.203c-2.508 0 -4.149 1.44 -4.149 4.047v2.293h-2.785v3.009h2.785v7.267h3.428v-7.267h2.556z"
      fill="var(--custom-social-icon-color, #FFAFB8)"
    />
  </svg>
);

const instagramIcon = (
  <svg
    width="32"
    height="32.445"
    viewBox="0 0 32 32.445"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      cx="35.75"
      cy="36.6113"
      r="35.75"
      fill="#4C3437"
      d="M31.778 16.271a15.886 15.886 0 0 1 -15.89 15.889A15.886 15.886 0 0 1 0 16.271a15.89 15.89 0 0 1 31.778 0"
    />
    <path
      d="M19.968 24.216h-8.223c-2.095 0 -3.802 -1.717 -3.802 -3.827v-7.514c0 -2.11 1.705 -3.827 3.802 -3.827h8.223c2.097 0 3.803 1.717 3.803 3.827v7.514c0 2.11 -1.705 3.827 -3.802 3.827M11.746 10.201a2.674 2.674 0 0 0 -2.658 2.675v7.514a2.674 2.674 0 0 0 2.658 2.675h8.223a2.674 2.674 0 0 0 2.658 -2.675v-7.514a2.674 2.674 0 0 0 -2.658 -2.675z"
      fill="#FFAFB8"
    />
    <path
      d="M15.858 20.804c-2.296 0 -4.163 -1.88 -4.163 -4.19s1.866 -4.189 4.163 -4.189 4.163 1.88 4.163 4.189 -1.866 4.19 -4.163 4.19m0 -7.227c-1.664 0 -3.018 1.363 -3.018 3.037s1.354 3.038 3.018 3.038 3.018 -1.363 3.018 -3.038 -1.354 -3.038 -3.018 -3.038"
      fill="#FFAFB8"
    />
    <path
      d="M20.482 12.829c0.373 0 0.676 -0.305 0.676 -0.681s-0.302 -0.681 -0.676 -0.681 -0.677 0.305 -0.677 0.681 0.302 0.681 0.677 0.681"
      fill="#FFAFB8"
    />
  </svg>
);

const mailIcon = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="16.3004"
      cy="15.9"
      rx="15.9"
      ry="15.9"
      fill="var(--custom-social-icon-background-color, #4C3437)"
    />
    <path
      d="M22.8505 10.8412H10.5919C9.08172 10.8412 9.0819 11.3178 9.08181 12.152L9.07422 20.0165C9.07422 21.2081 9.30772 21.3273 10.5919 21.3273H22.8505C24.018 21.3273 24.2515 21.3273 24.2515 20.0165V12.2711C24.2515 11.0795 24.2515 10.8412 22.8505 10.8412ZM24.2497 13.2244L16.6629 18.4675L9.08181 13.4627V12.152L16.6629 17.1567L24.2497 11.9136V13.2244Z"
      fill="var(--custom-social-icon-color, #FFAFB8)"
    />
  </svg>
);

const shareIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_4261_26096"
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4261_26096)">
      <path
        d="M22.9521 10.9521C24.2359 9.66836 26.3256 9.68502 27.6298 10.9892C28.9335 12.2934 28.9495 14.3823 27.6659 15.666C26.5115 16.8204 24.7057 16.9236 23.4052 15.9843L16.6005 20.0195C16.6468 20.4676 16.6004 20.9216 16.4638 21.3525L22.8534 25.0546C22.8853 25.0199 22.9184 24.9858 22.9521 24.9521C24.2359 23.6684 26.3256 23.685 27.6298 24.9892C28.9335 26.2934 28.9495 28.3823 27.6659 29.666C26.4222 30.9097 24.4227 30.9334 23.1132 29.748L22.9892 29.6298C22.0981 28.7388 21.8079 27.4811 22.123 26.3642L15.6913 22.6386C15.6827 22.6475 15.6747 22.6572 15.6659 22.666C14.4222 23.9097 12.4227 23.9334 11.1132 22.748L10.9892 22.6298C9.68496 21.3256 9.66823 19.2359 10.9521 17.9521C12.2359 16.6684 14.3256 16.685 15.6298 17.9892C15.8108 18.1703 15.9662 18.3671 16.0976 18.5742L22.3984 14.8369C21.723 13.5812 21.9053 11.9989 22.9521 10.9521ZM26.5683 26.0498C25.8341 25.3157 24.695 25.3304 24.0126 26.0126C23.3303 26.695 23.3156 27.8341 24.0497 28.5683C24.784 29.3024 25.9231 29.2877 26.6054 28.6054C27.2876 27.9231 27.3023 26.784 26.5683 26.0498ZM14.5683 19.0498C13.8341 18.3157 12.695 18.3304 12.0126 19.0126C11.3303 19.695 11.3156 20.8341 12.0497 21.5683C12.784 22.3024 13.9231 22.2877 14.6054 21.6054C15.2876 20.9231 15.3023 19.784 14.5683 19.0498ZM26.5683 12.0498C25.8341 11.3157 24.695 11.3304 24.0126 12.0126C23.3303 12.695 23.3156 13.8341 24.0497 14.5683C24.784 15.3024 25.9231 15.2877 26.6054 14.6054C27.2876 13.9231 27.3023 12.784 26.5683 12.0498Z"
        fill="#4C3437"
      />
    </g>
  </svg>
);

const tiktokIcon = (
  <svg
    width="32"
    height="32.444"
    viewBox="0 0 32 32.444"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      cx="36.25"
      cy="36.6113"
      r="35.75"
      fill="#4C3437"
      d="M32 16.272A15.889 15.889 0 0 1 16.111 32.161A15.889 15.889 0 0 1 0.222 16.272A15.889 15.889 0 0 1 32 16.272z"
    />
    <path
      d="M16.099 9.063c0.861 -0.013 1.716 -0.007 2.573 -0.013 0.025 0.986 0.438 1.927 1.152 2.633a4.738 4.738 0 0 0 2.789 1.131v2.547a7.244 7.244 0 0 1 -2.764 -0.613 8.444 8.444 0 0 1 -1.066 -0.586c-0.007 1.844 0.007 3.692 -0.014 5.529a4.711 4.711 0 0 1 -0.887 2.489c-0.887 1.231 -2.329 1.985 -3.891 2.03a4.956 4.956 0 0 1 -2.685 -0.652c-1.35 -0.769 -2.24 -2.106 -2.401 -3.609a10.222 10.222 0 0 1 -0.008 -0.941c0.269 -2.613 2.696 -4.523 5.42 -4.264q0.161 0.016 0.323 0.041c0.015 0.934 -0.025 1.872 -0.025 2.806 -1.178 -0.396 -2.466 0.196 -2.879 1.327q0.001 0.005 -0.004 0.01a2.444 2.444 0 0 0 -0.093 1.017c0.176 1.079 1.166 1.858 2.304 1.813 0.747 -0.021 1.432 -0.404 1.823 -1.017 0.147 -0.196 0.24 -0.428 0.269 -0.669 0.064 -1.131 0.04 -2.258 0.047 -3.388 0.007 -2.547 -0.007 -5.088 0.014 -7.628z"
      fill="#FFAFB8"
    />
  </svg>
);

const whatsappIcon = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="16.7008"
      cy="15.9"
      rx="15.9"
      ry="15.9"
      fill="var(--custom-social-icon-background-color, #4C3437)"
    />
    <path
      d="M23.0039 9.54642C21.3874 7.94657 19.2346 7.06665 16.9467 7.06665C12.2245 7.06665 8.3819 10.8606 8.3819 15.523C8.3819 17.0124 8.77542 18.4675 9.52388 19.7512L8.30859 24.1318L12.8495 22.9547C14.0995 23.6289 15.5077 23.9832 16.9429 23.9832H16.9467C21.6651 23.9832 25.5926 20.1893 25.5926 15.5268C25.5926 13.268 24.6204 11.1463 23.0039 9.54642ZM16.9467 22.5586C15.6659 22.5586 14.412 22.2196 13.3202 21.5796L13.0617 21.4272L10.3688 22.1243L11.0864 19.5303L10.9166 19.2636C10.2029 18.1437 9.82866 16.8524 9.82866 15.523C9.82866 11.6491 13.0231 8.49509 16.9506 8.49509C18.8526 8.49509 20.6389 9.22645 21.9815 10.5559C23.3241 11.8853 24.1497 13.6489 24.1459 15.5268C24.1459 19.4046 20.8704 22.5586 16.9467 22.5586ZM20.8511 17.2943C20.6389 17.1876 19.5856 16.6772 19.3889 16.6086C19.1921 16.5363 19.0494 16.502 18.9066 16.7153C18.7639 16.9286 18.3549 17.4009 18.2276 17.5457C18.1042 17.6866 17.9768 17.7057 17.7647 17.599C16.5069 16.9781 15.6813 16.4906 14.8518 15.085C14.6319 14.7117 15.0717 14.7383 15.4807 13.9308C15.5501 13.7898 15.5154 13.668 15.4614 13.5613C15.4074 13.4546 14.9791 12.4147 14.8017 11.9919C14.6281 11.5805 14.4506 11.6377 14.3194 11.63C14.196 11.6224 14.0532 11.6224 13.9105 11.6224C13.7677 11.6224 13.5362 11.6758 13.3395 11.8853C13.1427 12.0986 12.591 12.609 12.591 13.6489C12.591 14.6888 13.3588 15.6944 13.4629 15.8354C13.571 15.9763 14.9714 18.1095 17.1204 19.0275C18.4784 19.6065 19.0108 19.656 19.6898 19.5569C20.1026 19.496 20.9553 19.0465 21.1327 18.5513C21.3102 18.0561 21.3102 17.6333 21.2562 17.5457C21.206 17.4505 21.0633 17.3971 20.8511 17.2943Z"
      fill="var(--custom-social-icon-color, #FFAFB8)"
    />
  </svg>
);

const xIcon = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16.4996"
      cy="15.9"
      r="15.9"
      fill="var(--custom-social-icon-background-color, #4C3437)"
    />
    <path
      d="M17.6308 15.0279L21.4332 10.8411H20.0297L17.0008 14.1916L14.3092 10.8411H10.7168L15.1883 16.4483L11.127 20.9592H12.4862L15.8177 17.2847L18.7768 20.9592H22.2804L17.6308 15.0279ZM19.1374 19.8447L12.8691 11.9128H13.9094L20.1777 19.8447H19.1374Z"
      fill="var(--custom-social-icon-color, #FFAFB8)"
    />
  </svg>
);

const youtubeIcon = (
  <svg
    width="32"
    height="32.444"
    viewBox="0 0 32 32.444"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      cx="35.75"
      cy="36.6113"
      r="35.75"
      fill="#4C3437"
      d="M31.778 16.272A15.889 15.889 0 0 1 15.889 32.161A15.889 15.889 0 0 1 0 16.272A15.889 15.889 0 0 1 31.778 16.272z"
    />
    <path
      d="M24.346 20.521a2.213 2.213 0 0 1 -1.56 1.561c-1.376 0.369 -6.898 0.369 -6.898 0.369s-5.52 0 -6.897 -0.369a2.213 2.213 0 0 1 -1.561 -1.561c-0.369 -1.377 -0.369 -4.249 -0.369 -4.249s0 -2.872 0.369 -4.25a2.209 2.209 0 0 1 1.561 -1.56c1.377 -0.369 6.897 -0.369 6.897 -0.369s5.521 0 6.897 0.369a2.209 2.209 0 0 1 1.56 1.56c0.369 1.376 0.369 4.25 0.369 4.25s0 2.872 -0.369 4.249m-10.264 -6.858V18.88l4.614 -2.608z"
      fill="#FFAFB8"
    />
  </svg>
);

export {
  copyIconBrown,
  copyIconTransparent,
  facebookIcon,
  instagramIcon,
  mailIcon,
  shareIcon,
  tiktokIcon,
  whatsappIcon,
  xIcon,
  youtubeIcon,
};
